import Swiper from 'swiper'

const moduleName = 'stages-3'

module.exports = () => {
  const sliderEl = document.querySelector('.js-stages-3')

  if (!sliderEl) return;

  let slider = null

  function init () {

    if (window.innerWidth < 1024) {

      if (!slider) {
        slider = new Swiper('.js-stages-3', {
          slidesPerView: 'auto',
          freeMode: true,
          spaceBetween: 30,
          pagination: {
            el: '.stages-3__pagination'
          },
          scrollbar: {
            el: '.stages-3__scrollbar'
          },
          breakpoints: {
            767: {
              spaceBetween: 16,
              slidesPerView: 1,
              freeMode: false
            }
          }
        })
      }

    } else {

      if (slider) {
        slider.destroy()
        slider = null
      }

    }

  }

  init ()

  window.addEventListener('resize', () => init())
}